// Animated highway centerline — the recurring Nightline brand motif.
export const RoadLine = ({ light = false, className = "", testId = "road-line" }) => (
    <div
        data-testid={testId}
        aria-hidden="true"
        className={`h-[3px] w-full animate-road-dash ${light ? "road-line-light" : "road-line"} ${className}`}
    />
);

export default RoadLine;
